// DEPRECATED: To be removed later.

import sileo from 'sileo';
import axios from 'source/lib/axios';

const EmployeeTaskSummary = new sileo.Model('hqzen', 'task-summary');
const TaskSummaryDepartments = new sileo.Model('hqzen', 'task-summary-departments');
const TaskSummaryTeams = new sileo.Model('hqzen', 'task-summary-teams');
const TimelogExports = new sileo.Model('hqzen', 'timelog-exports');
const LeaveExports = new sileo.Model('hqzen', 'leave-exports');
const SupervisorManagerTaskSummary = new sileo.Model('hqzen', 'supervisor-manager-task-summary');
const ScheduledTasks = new sileo.Model('hqzen', 'employment-scheduled-tasks');
const Holidays = new sileo.Model('hqzen', 'employee-holidays');
const TaskSummaryEmployeePayroll = new sileo.Model('hqzen', 'task-summary-employee-payroll');


const actions = {
    fetchEmployeeTaskSummary(context, filters) {
        return EmployeeTaskSummary.objects.filter(filters);
    },

    fetchDepartments(context, filters) {
        return TaskSummaryDepartments.objects.filter(filters);
    },

    fetchTeams(context, filters) {
        return TaskSummaryTeams.objects.filter(filters);
    },

    fetchSupervisorManagerTaskSummary(context, filters) {
        return SupervisorManagerTaskSummary.objects.filter(filters);
    },

    fetchExports(context, filters) {
        return TimelogExports.objects.filter(filters);
    },

    fetchLeaveExports(context, filters) {
        return LeaveExports.objects.filter(filters);
    },

    createExport(context, data) {
        const form = new FormData();
        form.append('title', data.title);
        form.append('eta', data.eta);
        form.append('section', data.section);
        form.append('sectionPk', data.sectionPk);
        form.append('selected', JSON.stringify(data.selected));
        form.append('date__gte', data.date__gte);
        form.append('date__lt', data.date__lt);
        form.append('workforce_id', data.workforce_id);
        form.append('company_id', data.company_id);
        form.append('fields_to_export', JSON.stringify(data.fields_to_export));
        form.append('selected_timezone', data.selected_timezone);

        return TimelogExports.objects.create(form);
    },

    createLeaveExport(context, data) {
        const form = new FormData();

        form.append('title', data.title);
        form.append('eta', data.eta);
        form.append('members', data.members);
        form.append('section', data.section);
        form.append('sectionPk', data.sectionPk);
        form.append('selected', JSON.stringify(data.selected));
        form.append('date__gte', data.date__gte);
        form.append('date__lt', data.date__lt);
        form.append('company_id', data.company_id);
        form.append('fields_to_export', JSON.stringify(data.fields_to_export));
        form.append('selected_timezone', data.selected_timezone);

        if (data.workforce_id) form.append('workforce_id', data.workforce_id);

        return LeaveExports.objects.create(form);
    },

    downloadTimelogExportCSV(context, params) {
        return axios.get('hqzen/timelog-export-download', {
            params: params
        });
    },

    removeExport(context, filters) {
        return TimelogExports.objects.delete(filters);
    },

    fetchScheduledTasks(context, filters) {
        return ScheduledTasks.objects.filter(filters);
    },

    fetchHolidays(context, filters) {
        return Holidays.objects.filter(filters);
    },

    fetchTaskSummaryEmployeePayroll(_, filters) {
        // We're using filter here, although we need only a single instance,
        // we need to give filters in order to get the correct payroll.
        return TaskSummaryEmployeePayroll.objects.filter(filters);
    },
};

export default {
    namespaced: true,
    actions
};
